import React from 'react';
import { jsx } from '@emotion/core';
import moment from 'moment';
import { IdentificationType } from '../../../utils/types';
import DataTable from '../../../components/table/DataTable';
/**@jsx jsx*/

type Actions = {
  label: string;
  action: (gender: IdentificationType) => void;
}[];

interface IProps {
  identificationTypes?: IdentificationType[];
  actions: Actions;
  isLoading?: boolean;
}

const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (createdAt: Date) => {
      return <span>{moment(createdAt).format('DD/MM/YYYY')}</span>;
    },
  },
  {
    title: 'Last Changed',
    dataIndex: 'lastChanged',
    key: 'lastChanged',
    render: (lastChanged: Date) => {
      return <span>{moment(lastChanged).format('DD/MM/YYYY')}</span>;
    },
  },
];

const IdentificationTypesTable: React.FC<IProps> = ({
  identificationTypes = [],
  actions,
  isLoading,
}) => {
  return (
    <DataTable
      showControls
      showPagination
      data={identificationTypes}
      columns={columns}
      actions={actions}
      searchFilter="name"
      isLoading={isLoading}
    />
  );
};

export default IdentificationTypesTable;
